import React, { forwardRef } from 'react'
import ConfirmPopup from './ConfirmPopup'

export default forwardRef(function ResetPasswordPopup(props, ref) {
    return (
        <ConfirmPopup
            type="resetPassword"
            {...props}
            onOk={props.onResetPassword}
            ref={ref}
        />
    )
})
 